import { useEffect, useState } from "react";
import api from "../utils/api";

export default function RoleAccess({ allow, children, role }) {
  const [localRole, setLocalRole] = useState(role);
  const [loading, setLoading] = useState(!role);

  useEffect(() => {
    if (role) {
      setLocalRole(role);
      setLoading(false);
      return;
    }

    api
      .get("/users/me", { withCredentials: true })
      .then((res) => setLocalRole(res.data.role))
      .catch(() => setLocalRole(null))
      .finally(() => setLoading(false));
  }, [role]);

  if (loading) return null;

  if (!localRole || !allow.includes(localRole)) {
    return null;
  }

  return children;
}
